import _ from "lodash"
import styled, { createGlobalStyle } from "styled-components"
import { Colors } from 'styles/app-styles'

export const FolderExplorerContainer = styled.div`
  display: grid;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  grid-gap: 15px;
  grid-template-columns: 30% 70%;
  grid-template-rows: 30px auto;
  grid-template-areas:
  "search breadcrumbs"
  "folder-nav folder-details";
  height: calc(100% - 150px);
  margin: 15px;
  margin-top: -20px;
  position: absolute;
  width: calc(100% - 46px);
  user-select: none;

  [data-tooltip] {
    position: relative;
  }

  [data-tooltip]::after {
    display: none;
    position: fixed;
    content: attr(data-tooltip);
    border: 1px solid ${Colors.darkDenim};
    background: ${Colors.lightMystic};
    padding: .25em;
    border-radius: 5px;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    pointer-events: none;
    z-index: 899;
    left: var(--tooltip-x, 0);
    top: var(--tooltip-y, 0);
  }

  [data-tooltip].tooltip-visible::after {
    display: block;
    animation: showTooltip 0s .6s forwards;
  }

  @keyframes showTooltip {
    to {
        opacity: 1;
    }
  }

  td {
    white-space: nowrap;
  }

  .search {
    width: 100%;

    input {
      border: 1px solid ${Colors.towerGrey};
      background-color: ${Colors.lightMystic};
      width: 100%;
      height: 100%;
      padding-left:8px;
    }
  }

  .breadcrumbs {
    border: 1px solid ${Colors.towerGrey};
    background-color: ${Colors.lightMystic};
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left:6px;

    span {
      margin-left: 4px;
    }

    .path-item {
      display: inline-block;
    }

    .path-text {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      &:hover {
        color: ${Colors.darkDenim}
      }
    }

    .icon {
      display: inline-block;
      height: 18px;

      & > path {
        fill: #3E506F;
      }
    }

    .caret-icon {
      display: inline-block;
      height: 14px;
      margin-top: 1px;
      margin-left: 4px;
      vertical-align:middle
    }

    svg {
      height: 20px;
      .r-svg { fill: ${Colors.blackPearl}; }
    }
  }

  .folder-details {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    border: 1px solid ${Colors.towerGrey};

    .details-table {
      overflow: auto;

      thead.p-datatable-thead > tr {
        height: 30px;
        border-bottom: 1px solid #C5D7DC;
        & > th {
          font-weight: normal;
        }
      }

      .p-datatable-scrollable-view {
        display: hidden;
      }

      .p-datatable-scrollable-header {
        position: sticky;
        top: 0;
        z-index: 1;
        opacity: 1;
        background-color: white;
      }

      .p-datatable-scrollable-body {
        //height: calc(100vh - 228px);
      }

      tbody.p-datatable-tbody > tr {
        height: 27.5px;
        &:nth-child(2n){
          background: ${Colors.lightMystic};
        }
        &:hover, &.p-highlight {
          cursor: pointer;
          background-color: ${Colors.heatherGrey};
        }
      }

      .p-sortable-column {
        text-align: left;
      }

      svg {
        height: 14px;
        margin-top: 2px;
      }

      svg > path {
        fill: #3E506F;
      }
    }

    .total-items {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: auto;
      width: 100%;
      height: 30px;
      padding: 8px;
      border-top: 1px solid ${Colors.towerGrey};
      background-color: ${Colors.lightMystic};
    }
  }

  .p-contextmenu {
    font-size: 14px;
  }
`

export const GlobalStyleOverrides = createGlobalStyle`
  html {
    overflow: hidden;
  }

  .p-contextmenu {
    font-size: 14px;

    li {
      min-width: 130px;
      &:hover {
        background-color: ${Colors.lightMystic};
      }
    }
  }
`

export const NavItemContainer_s = styled.div`
  position: relative;
  /* overflow-x: visible !important; */
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  border: 1px solid ${Colors.towerGrey};
  ${props => _.get(props, "minWidth") ? `min-width: ${_.get(props, "minWidth")}px` : ''};
  ${props => _.get(props, "minHeight") ? `min-height: ${_.get(props, "minHeight")}px` : ''};
  ${props => _.get(props, "maxHeight") ? `max-height: ${_.get(props, "maxHeight")}px` : ''};
  overflow-y: scroll;

  ul {
    position: relative;
    list-style: none;
    width: 100%;

    li {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
    }
  }

  .root, .li-content {
    display: inline-flex;
    align-content: center;
    justify-content: left;
    user-select: none;
    width:100%;
    cursor:pointer;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 4px;
    padding-bottom: 2px;
    &.dragover {
      font-weight: bold;
      background-color: ${Colors.lightMystic};
    }
    &:hover {
      background-color: ${Colors.lightMystic};
    }
    &.focused {
      background-color: ${Colors.heatherGrey};
    }
  }

  .root {
    padding-top: 6px;
    padding-bottom: 6px;
    .root-name {
      padding-top: 2px;
    }
  }

  .li-container {
    width: 100%;
  }

  .children > * {
    width: 100%;
    padding-left: 18px;
  }

  .code {
    padding-top: 2px;

    .highlight {
      background-color: #f9fc687a;
    }
  }

  .icon {
    display: inline-block;
    height: 18px;
  }

  .home-icon {
    display: inline-block;
    height: 18px;
    padding-right: 4px;

    & > path {
      fill: #3E506F;
    }
  }

  .caret-icon {
    width:18px;
    padding-left: 3px;
  }

  .folder-icon {
    padding-right: 6px;
  }

  svg {
    height: 20px;
    .r-svg { fill: ${Colors.blackPearl}; }
  }
`
